export function getPhoneNumber(contact) {
    if(contact && contact.addresses && contact.addresses.length >= 1) {
        return contact.addresses[0].phone1;
    }
    return null;
}

export function getFullAddress(values) {
    const array = [];
    if(values.address1) {
        array.push(values.address1);
    }
    if(values.address2) {
        array.push(values.address2);
    }
    if(values.city) {
        array.push(values.city);
    }
    if(values.state) {
        array.push(values.state);
    }
    if(values.state) {
        array.push(values.zip);
    }

    if(array.length >= 1) {
        return array.join(", ");
    }

    return null;
}